import React from "react";
import "./HeroSection.css";

const HeroSection = (props) => {
  return <div className="other-page-hero-section text-center d-flex mb-5">
      <h1 className="other-page-hero-title">{props.name}</h1>
      <h4>{`Home > ${props.name} >` }</h4>

  </div>;
};

export default HeroSection;
